export const badge = {
  root: {
    borderRadius: "{border.radius.6}",
    padding: "0 {padding.2}",
    fontSize: "{content.font.size}",
    fontWeight: "700",
    minWidth: "24px",
    height: "24px",
  },
  dot: {
    size: "10px",
  },
  sm: {
    fontSize: "10px",
    minWidth: "14px",
    height: "14px",
  },
  // lg: {
  //   fontSize: "0.875rem",
  //   minWidth: "1.75rem",
  //   height: "1.75rem",
  // },
  // xl: {
  //   fontSize: "1rem",
  //   minWidth: "2rem",
  //   height: "2rem",
  // },

  colorScheme: {
    light: {
      // primary: {
      //   background: "{primary.color}",
      //   color: "{primary.contrast.color}",
      // },
      // secondary: {
      //   background: "{surface.100}",
      //   color: "{surface.600}",
      // },
      success: {
        background: "{success.default}",
        color: "{color.white}",
      },
      info: {
        background: "{info.default}",
        color: "{color.white}",
      },
      warn: {
        background: "{warning.default}",
        color: "{color.white}",
      },
      danger: {
        background: "{danger.default}",
        color: "{color.white}",
      },
      // contrast: {
      //   background: "{surface.950}",
      //   color: "{surface.0}",
      // },
    },
    dark: {
      // primary: {
      //   background: "{primary.color}",
      //   color: "{primary.contrast.color}",
      // },
      // secondary: {
      //   background: "{surface.100}",
      //   color: "{surface.600}",
      // },
      success: {
        background: "{success.support}",
        color: "{color.white}",
      },
      info: {
        background: "{info.support}",
        color: "{color.white}",
      },
      warn: {
        background: "{warning.support}",
        color: "{color.white}",
      },
      danger: {
        background: "{danger.support}",
        color: "{color.white}",
      },
      // contrast: {
      //   background: "{surface.950}",
      //   color: "{surface.0}",
      // },
    },
  },
  extend: {
    ui: {
      dot: {
        info: {
          shadow: "0 0 8px {color.blue.400}",
        },
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-badge-dot.p-badge-info {
      box-shadow: ${dt("badge.ui.dot.info.shadow")};
    }

    .p-badge-circle {
      border-radius: ${dt("badge.border.radius")};
    }
    
    .badge-pulse {
      animation: badge-pulse 0.4s ease-in-out;
    }
    
    @keyframes badge-pulse {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.3);
      }
      100% {
        transform: scale(1);
    }
}
    
  `,
};
